module.exports = __webpack_public_path__ + "Flag-670.e646417074c0ab7788c288983f10b634.svg";